/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { SMPPClientCredential } from '../model/sMPPClientCredential';
import { SMPPClientCredentialDto } from '../model/sMPPClientCredentialDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SMPPClientCredentialService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSMPPClientCredentialDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSMPPClientCredentialDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSMPPClientCredentialDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSMPPClientCredentialDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/SMPPClientCredential`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param routeId 
     * @param systemId 
     * @param password 
     * @param agreggatorId 
     * @param serviceProviderEmail 
     * @param serviceProviderName 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSMPPClientCredentialDetailGet(id?: string, routeId?: string, systemId?: string, password?: string, agreggatorId?: string, serviceProviderEmail?: string, serviceProviderName?: string, serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<SMPPClientCredential>;
    public apiSMPPClientCredentialDetailGet(id?: string, routeId?: string, systemId?: string, password?: string, agreggatorId?: string, serviceProviderEmail?: string, serviceProviderName?: string, serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SMPPClientCredential>>;
    public apiSMPPClientCredentialDetailGet(id?: string, routeId?: string, systemId?: string, password?: string, agreggatorId?: string, serviceProviderEmail?: string, serviceProviderName?: string, serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SMPPClientCredential>>;
    public apiSMPPClientCredentialDetailGet(id?: string, routeId?: string, systemId?: string, password?: string, agreggatorId?: string, serviceProviderEmail?: string, serviceProviderName?: string, serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', <any>id);
        }
        if (routeId !== undefined && routeId !== null) {
            queryParameters = queryParameters.set('routeId', <any>routeId);
        }
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('SystemId', <any>systemId);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('Password', <any>password);
        }
        if (agreggatorId !== undefined && agreggatorId !== null) {
            queryParameters = queryParameters.set('AgreggatorId', <any>agreggatorId);
        }
        if (serviceProviderEmail !== undefined && serviceProviderEmail !== null) {
            queryParameters = queryParameters.set('ServiceProviderEmail', <any>serviceProviderEmail);
        }
        if (serviceProviderName !== undefined && serviceProviderName !== null) {
            queryParameters = queryParameters.set('ServiceProviderName', <any>serviceProviderName);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('ServiceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SMPPClientCredential>('get',`${this.basePath}/api/SMPPClientCredential/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param systemId 
     * @param password 
     * @param agreggatorId 
     * @param serviceProviderEmail 
     * @param serviceProviderName 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSMPPClientCredentialDetailsGet(systemId?: string, password?: string, agreggatorId?: string, serviceProviderEmail?: string, serviceProviderName?: string, serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SMPPClientCredential>>;
    public apiSMPPClientCredentialDetailsGet(systemId?: string, password?: string, agreggatorId?: string, serviceProviderEmail?: string, serviceProviderName?: string, serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SMPPClientCredential>>>;
    public apiSMPPClientCredentialDetailsGet(systemId?: string, password?: string, agreggatorId?: string, serviceProviderEmail?: string, serviceProviderName?: string, serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SMPPClientCredential>>>;
    public apiSMPPClientCredentialDetailsGet(systemId?: string, password?: string, agreggatorId?: string, serviceProviderEmail?: string, serviceProviderName?: string, serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('SystemId', <any>systemId);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('Password', <any>password);
        }
        if (agreggatorId !== undefined && agreggatorId !== null) {
            queryParameters = queryParameters.set('AgreggatorId', <any>agreggatorId);
        }
        if (serviceProviderEmail !== undefined && serviceProviderEmail !== null) {
            queryParameters = queryParameters.set('ServiceProviderEmail', <any>serviceProviderEmail);
        }
        if (serviceProviderName !== undefined && serviceProviderName !== null) {
            queryParameters = queryParameters.set('ServiceProviderName', <any>serviceProviderName);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('ServiceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SMPPClientCredential>>('get',`${this.basePath}/api/SMPPClientCredential/details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSMPPClientCredentialPost(body?: SMPPClientCredentialDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSMPPClientCredentialPost(body?: SMPPClientCredentialDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSMPPClientCredentialPost(body?: SMPPClientCredentialDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSMPPClientCredentialPost(body?: SMPPClientCredentialDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/SMPPClientCredential`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSMPPClientCredentialPut(body?: SMPPClientCredential, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiSMPPClientCredentialPut(body?: SMPPClientCredential, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiSMPPClientCredentialPut(body?: SMPPClientCredential, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiSMPPClientCredentialPut(body?: SMPPClientCredential, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/SMPPClientCredential`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param systemId 
     * @param password 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSMPPClientCredentialSmppAuthenticationGet(systemId?: string, password?: string, observe?: 'body', reportProgress?: boolean): Observable<SMPPClientCredential>;
    public apiSMPPClientCredentialSmppAuthenticationGet(systemId?: string, password?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SMPPClientCredential>>;
    public apiSMPPClientCredentialSmppAuthenticationGet(systemId?: string, password?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SMPPClientCredential>>;
    public apiSMPPClientCredentialSmppAuthenticationGet(systemId?: string, password?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('systemId', <any>systemId);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SMPPClientCredential>('get',`${this.basePath}/api/SMPPClientCredential/smppAuthentication`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param systemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSMPPClientCredentialSystemIdsystemIdGet(systemId: string, observe?: 'body', reportProgress?: boolean): Observable<SMPPClientCredentialDto>;
    public apiSMPPClientCredentialSystemIdsystemIdGet(systemId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SMPPClientCredentialDto>>;
    public apiSMPPClientCredentialSystemIdsystemIdGet(systemId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SMPPClientCredentialDto>>;
    public apiSMPPClientCredentialSystemIdsystemIdGet(systemId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling apiSMPPClientCredentialSystemIdsystemIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SMPPClientCredentialDto>('get',`${this.basePath}/api/SMPPClientCredential/systemId${encodeURIComponent(String(systemId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
